import { ID } from './id';

export enum ReminderBasedOn {
  Start = 'start',
  End = 'end',
  DayStart = 'dayStart',
}

export type Reminder = {
  id?: ID | null;
  offset: number;
  basedOn: ReminderBasedOn;
};
